<div class="sec-title">
    <h1>Calendrier des suivis</h1>
</div>
<hr>
<div class="col-12" id="suivis-cal">
  <div class="row col-12"> 
    <div class="col-12">
      <full-calendar #calendar [options]="calendarOptions" class="col-12"></full-calendar>
    </div>
  </div>
  <div class="row col-12"> 
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Suivi francais:</th>
          <th scope="col">Suivi anglais:</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row" class="col-8">
            <div class="badge badge-med" style="background-color:{{this.year_color_fr_4}};">
              <small>2024</small>
            </div>
            <div class="badge badge-med" style="background-color:{{this.year_color_fr_0}};">
              <small>2025</small>
            </div>
            <div class="badge badge-med" style="background-color:{{this.year_color_fr_1}};">
              <small>2026</small>
            </div>
            <div class="badge badge-med" style="background-color:{{this.year_color_fr_2}};">
              <small>2027</small>
            </div>
          </th>

          <td  class="col-4">          
            <div class="badge badge-med" style="background-color:{{this.year_color_en_4}};">
              <small>2024</small>
            </div>
            <div class="badge badge-med" style="background-color:{{this.year_color_en_0}};">
              <small>2025</small>
            </div>
            <div class="badge badge-med" style="background-color:{{this.year_color_en_1}};">
              <small>2026</small>
            </div>
            <div class="badge badge-med" style="background-color:{{this.year_color_en_2}};">
              <small>2027</small>
            </div>
          </td>

        </tr>
        <tr>
          <th>
            <div class="badge badge-med" style="background-color:{{this.year_color_fr_bfr}};">
              <small>2017-2023 </small>
            </div>
          </th>
          <td  class="col-4"> 
              <div class="badge badge-med" style="background-color:{{this.year_color_en_bfr}};">
                <small>2017-2023</small>
              </div>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</div>

<div id="eventModal" class="modal fade" tabindex="-1">
  <!-- Vertically centered scrollable modal -->
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">{{modalTitle}}</h5>
              <button type="button" id="updatePropositionForm-close" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
          </div>
          <div class="modal-body">
              <div class="form-group mb-3">
                <address>{{eventAddress}}</address>
              </div>
              <div class="form-group mb-3">
                <span>Début: </span><span>{{eventStartDate}}</span>
              </div>
              <div class="form-group mb-3">
                <span>Fin: </span><span>{{eventEndDate}}</span>
              </div>
              <div class="form-group mb-3">
                <button type="button">Voir plus de détails</button>
              </div>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
          </div>
      </div>
  </div>
</div>
<hr>